import { useCallback } from 'react'
import { AddonResultDetails } from '../list-view/list-view'
import { AddOnTypes } from '@Config/types'
import { Utils } from '@Util/utils'
import { useSelector } from 'react-redux'
import { RootState } from '@AppState/redux-store'

import './styles.scss'

export type TicketFormAddOnListProps = {
  addOnDetails: AddonResultDetails[]
  multiplierValue: number | undefined
}

const CLASS_NAME = `gby-k2g-animation-ticket-form-addon-list`

export const TicketFormAddOnList = (props: TicketFormAddOnListProps) => {
  const hostConfig = useSelector((state: RootState) => state.hostConfig.config)

  const renderAddOns = useCallback(() => {
    const elements = props.addOnDetails.map((addon, index) => {
      let displayValue = addon.name

      if (addon.type === AddOnTypes.MULTIPLIER) {
        displayValue = props.multiplierValue
          ? addon.name +
            ': ' +
            Utils.getMultiplierDisplayValue(
              props.multiplierValue,
              hostConfig?.multiplierConfig.noMultiplierDisplayString,
            )
          : addon.name
      }

      return (
        <div className={`${CLASS_NAME}__addon`} key={`${CLASS_NAME}__addon_${index}`}>
          {index > 0 ? (
            <div
              className={`${CLASS_NAME}__addon-divider`}
              key={`${CLASS_NAME}__addon-divider_${index}`}>
              {' \u2022 '}
            </div>
          ) : null}
          {addon.color ? (
            <div
              className={`${CLASS_NAME}__addon-legend-color`}
              key={`${CLASS_NAME}__addon-legend-color_${index}`}
              style={{ backgroundColor: addon.color }}
            />
          ) : null}
          <div className={`${CLASS_NAME}__addon-name`} key={`${CLASS_NAME}__addon-name_${index}`}>
            {displayValue}
          </div>
        </div>
      )
    })

    return <div className={`${CLASS_NAME}__addon-group`}>{elements}</div>
  }, [
    props.addOnDetails,
    props.multiplierValue,
    hostConfig?.multiplierConfig.noMultiplierDisplayString,
  ])

  if (props.addOnDetails.length === 0) return null

  return renderAddOns()
}
